import { actionTypes } from './actions';

export const initialState = {
  packages: [],
  optionsSelected: {
    credits: 0,
    devices: 0,
    voiceClonings: 0,
    concurrentRequestApi: 0,
  },
};

export default function packageReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ADD_PACKAGE: {
      const { packages } = action;
      return { ...state, packages };
    }

    case actionTypes.UPDATE_OPTIONS_SELECTED: {
      const { optionsSelected } = action;
      return {
        ...state,
        optionsSelected: { ...state.optionsSelected, ...optionsSelected },
      };
    }

    default:
      return state;
  }
}
